<app-header-four [sticky]="true"  *ngIf="url != '/pages/comingsoon'"></app-header-four>
<router-outlet></router-outlet>
<!-- <app-footer-one *ngIf="url != '/pages/comingsoon'"></app-footer-one> -->
<app-footer-three></app-footer-three>
